import React, { useEffect } from 'react';
import cn from 'classnames';
import styles from './Root.module.scss';

const Root = ({ children, fullScreen }) => {
  useEffect(() => {
    if (fullScreen) {
      document.body.classList.add(styles.bodyHidden);
    } else {
      document.body.classList.remove(styles.bodyHidden);
    }
  }, [fullScreen]);

  return (
    <div
      className={cn(styles.root, {
        [styles.fullScreen]: fullScreen,
      })}
    >
      {children}
    </div>
  );
};

export default Root;
